
export function freezeObject(object) {
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(object)) {
    // eslint-disable-next-line no-prototype-builtins
    if (object.hasOwnProperty(key) && typeof value === 'object' && value !== null) {
      freezeObject({ ...value });
    }
  }

  Object.freeze(object);
  return object;
}

export function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}

export function deepEqual(obj1, obj2) {
  if (obj1 === obj2) return true;

  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  let result = true;
  keys1.forEach((key) => {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      result = false;
    }
  });

  return result;
}
